<template>
  <!-- eslint-disable -->
  <div>
    <b-modal @hidden="$parent.closeManageVisits()" hide-footer size='lg' ref='modalManageVisits' id="modalManageVisits"
             title="Resumen visitas">
      <b-form>
        <b-row>
          <b-col :cols='12'>
            <div>
              <b-form-checkbox id="checkbox1"
                               v-model="inputs.showWeeks.value"
                               :value="true"
                               :unchecked-value="false">
                Seleccionar semanas
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row class='mt-3'>
          <b-col :cols='2' v-if='inputs.showWeeks.value === false'>
            Fecha inicio
            <datepicker :bootstrap-styling='true' :format='customFormatter' v-model="inputs.dateStart.value"
                        name="dateStart"></datepicker>
            <span class="error" v-if="checkStartDate">La fecha de inicio es mayor que la fecha fin</span>
          </b-col>
          <b-col :cols='2' v-if='inputs.showWeeks.value === false'>
            Fecha fin
            <datepicker :bootstrap-styling='true' :format='customFormatter' v-model="inputs.dateEnd.value"
                        name="dateEnd"></datepicker>
          </b-col>
          <b-col :cols='2' v-if='inputs.showWeeks.value === true'>
            Fecha inicio (semana)
            <b-form-select v-model="inputs.dateStart.value" :options="inputs.dateStart.availableWeeks" class="mb-3"
                           size="sm"/>
            <span class="error" v-if="checkStartDate">La fecha de inicio es mayor que la fecha fin</span>
          </b-col>
          <b-col :cols='2' v-if='inputs.showWeeks.value === true'>
            Fecha fin (semana)
            <b-form-select v-model="inputs.dateEnd.value" :options="inputs.dateEnd.availableWeeks" class="mb-3"
                           size="sm"/>
          </b-col>

          <b-col :cols='3'>
            Grupo
            <b-form-select v-model="inputs.group.value" :options="inputs.group.options" class="mb-3" size="sm"/>
          </b-col>

          <b-col :cols='3'>
            Distribuidora
            <multiselect placeholder="Todas" deselect-label="Click o enter para deseleccionar"
                         select-label="Click o enter para seleccionar" v-model="inputs.distributor.value"
                         :options="inputs.distributor.options"
                         :multiple="true" :close-on-select="false"
                         :clear-on-select="false" :preserve-search="true" label="name" track-by="name"
                         :preselect-first="true">
            </multiselect>
          </b-col>

          <b-col :cols='2'>
            &nbsp;
            <b-button size='lg' @click='submitFilters' :block='true' variant='primary'>Buscar</b-button>
          </b-col>

        </b-row>

        <b-row>
          <b-col :cols='12'>
            <ManageVisitsResults v-if="showManageVisitsResultsPopup" :inputs="inputs" :data='resultsData'
                                 :group='this.inputs.group.value'></ManageVisitsResults>
          </b-col>
        </b-row>
      </b-form>

    </b-modal>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';

import moment from 'moment';

import ManageVisitsResults from './ManageVisitsResults';
import EventBus from '../../Modules/EventBus';

export default {
  name: 'ManageVisits',
  props: ['permisos'],
  components: {Datepicker, ManageVisitsResults},
  Multiselect,
  data () {
    return {
      showManageVisitsResultsPopup: false,
      resultsData: null,
      inputs: {
        showWeeks: {
          value: true,
          options: [{text: 'Semanas', value: true}, {text: 'Meses', value: false}]
        },
        dateStart: {
          value: null,
          availableWeeks: []
        },
        dateEnd: {
          value: null,
          availableWeeks: []

        },
        group: {
          value: 'comercial',
          options: [{text: 'Caldera', value: 'caldera'}, {text: 'Comercial', value: 'comercial'}, {
            text: 'Entidades',
            value: 'entidad'
          }]
        },
        distributor: {
          value: [],
          options: []
        }
      },
      loading: 0,
      userForm: false,
      columns: [],
      modalTitle: 'Resumen visitas',
      newUser: {
        nick: '',
        email: '',
        nombre: '',
        apellidos: '',
        metadatos: ''
      }
    };
  },
  computed: {
    checkStartDate () {
      return this.customFormatter(this.inputs.dateStart.value) > this.customFormatter(this.inputs.dateEnd.value);
    }
  },
  created: function () {
    this.populateAvailableWeeks();
    this.populateAvailableDistributors();
  },
  mounted: function () {
    this.$refs.modalManageVisits.show();
  },
  methods: {

    submitFilters () {
      this.showManageVisitsResultsPopup = false;

      if (this.inputs.dateStart.value == null || this.inputs.dateEnd.value == null) {
        EventBus.$emit('show-warning-alert', 'Es necesario seleccionar fecha inicio y fecha fin para realizar la búsqueda');
        return;
      }

      let dateStart = moment(this.inputs.dateStart.value).format('YYYY-MM-DD');
      let dateEnd = moment(this.inputs.dateEnd.value).format('YYYY-MM-DD');
      let group = this.inputs.group.value;

      let distribuidor = this.inputs.distributor.value.map(function (obj) {
        return obj.value;
      });

      // console.log(dateStart, dateEnd, group, distribuidor)

      if (group === 'entidad') {
        this.$http.get('visita_entidad/', {
          params: {
            'dateEnd': dateEnd,
            'dateStart': dateStart,
            'distributors': distribuidor
          }
        }).then(response => {
          this.showManageVisitsResultsPopup = true;
          this.resultsData = response.data;
        });
      } else if (group === 'comercial') {
        this.$http.get('visita_comercial/', {
          params: {
            'dateEnd': dateEnd,
            'dateStart': dateStart,
            'distributors': distribuidor
          }
        }).then(response => {
          this.showManageVisitsResultsPopup = true;
          this.resultsData = response.data;
        });
      } else if (group === 'caldera') {
        this.$http.get('visita_caldera/', {
          params: {
            'dateEnd': dateEnd,
            'dateStart': dateStart,
            'distributors': distribuidor
          }
        }).then(response => {
          this.showManageVisitsResultsPopup = true;
          this.resultsData = response.data;
        });
      }
    },

    populateAvailableWeeks () {
      this.$http.get('visita_' + this.inputs.group.value + '/first_and_last_days/').then(result => {
        let firstVisitDayOfYear = moment(result.data.firstDay);
        let lastVisitDayOfYear = moment(result.data.lastday);

        // Calculamos las semanas para que se calculen de sábado a viernes
        // El primer dia de la semana (firstStartWeekDay) debe ser sábado (6). Si weekDay es lunes-viernes, el inicio es el sábado anterior (-1)
        const isoStartWeekDay = (firstVisitDayOfYear.isoWeekday() > 5) ? 6 : -1;
        const firstStartWeekDay = firstVisitDayOfYear.startOf('week').clone().isoWeekday(isoStartWeekDay);

        const optionsDateStart = [];
        const optionsDateEnd = [];

        let currentStartWeekDay = firstStartWeekDay.clone();

        // eslint-disable-next-line no-unmodified-loop-condition
        while (currentStartWeekDay <= lastVisitDayOfYear) {
          let startWeekDay = currentStartWeekDay.clone();
          let endWeekDay = startWeekDay.clone().add(6, 'days');
          let numWeek = endWeekDay.isoWeek();

          optionsDateStart.push({
            value: startWeekDay.format('YYYY-MM-DD'),
            text: (numWeek + ' (' + startWeekDay.format('YYYY-MM-DD') + ' - ' + endWeekDay.format('YYYY-MM-DD') + ')')
          });

          optionsDateEnd.push({
            value: endWeekDay.format('YYYY-MM-DD'),
            text: (numWeek + ' (' + startWeekDay.format('YYYY-MM-DD') + ' - ' + endWeekDay.format('YYYY-MM-DD') + ')')
          });

          currentStartWeekDay.add(1, 'week');
        }

        this.inputs.dateStart.availableWeeks = optionsDateStart;
        this.inputs.dateEnd.availableWeeks = optionsDateEnd;
      });
    },
    populateAvailableDistributors () {
      this.$http.get('distribuidoras/').then(response => {
        let options = [];

        const distribuitorsList = response.data;
        distribuitorsList.forEach(distributor => {
          options.push({
            value: distributor.nombre,
            name: distributor.nombre
          });
        });

        // Añadimos la opción DESCONOCIDA para filtrar por las visitas que no tienen distribuidora asignada
        options.push({
          value: 'DESCONOCIDA',
          name: 'DESCONOCIDA'
        });

        this.inputs.distributor.options = options;
      });
    },

    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD');
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisits.vue